export enum WorklistType {
  User = 'USER',
  Group = 'WORKGROUP',
  MyTasks = 'MY_ TASKS'
}